/* import __COLOCATED_TEMPLATE__ from './edit-business-information.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { FieldIdentifier as AddressFieldIdentifier } from '@banking/ui/models/common/address';
import assert, { assertInstanceOf } from '@banking/ui/utils/assert';
import { BusinessFieldIdentifier } from '@banking/ui/models/checking/onboarding/edit-business-information';
import { EmployerIdentificationNumberFormatter, TextField } from 'field-kit';
let EditBusinessInformation = (_class = class EditBusinessInformation extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "ein", _descriptor2, this);
    _initializerDefineProperty(this, "confirmEin", _descriptor3, this);
    _initializerDefineProperty(this, "einErrorMessage", _descriptor4, this);
    _initializerDefineProperty(this, "confirmEinErrorMessage", _descriptor5, this);
    _defineProperty(this, "EIN_IDENTIFIER", BusinessFieldIdentifier.EIN);
    _defineProperty(this, "CONFIRM_EIN_IDENTIFIER", BusinessFieldIdentifier.CONFIRM_EIN);
    _defineProperty(this, "BUSINESS_NAME_IDENTIFIER", BusinessFieldIdentifier.BUSINESS_NAME);
  }
  handleCopyPersonalAddressCheckboxClicked(event) {
    this.args.userClickCopyPersonalAddress(event.detail.current === true);
  }
  async initializeFieldKit(fieldCandidate, marketInputTextElement) {
    assert(fieldCandidate != null && typeof fieldCandidate === 'string' && (fieldCandidate === BusinessFieldIdentifier.EIN || fieldCandidate === BusinessFieldIdentifier.CONFIRM_EIN));
    const inputElement = await marketInputTextElement.getInputElement();
    const formatter = new EmployerIdentificationNumberFormatter();

    // Init the value for EIN input text, but do not init a value for CONFIRM_EIN
    if (this.args.initialEinValue && fieldCandidate === BusinessFieldIdentifier.EIN) {
      // eslint-disable-next-line require-atomic-updates
      marketInputTextElement.value = formatter.format(this.args.initialEinValue);
    }
    const fieldKit = new TextField(inputElement, formatter);
    const textDidChange = field => this.onInputChange(fieldCandidate, field.value());
    fieldKit.setDelegate({
      textDidChange
    });
  }
  onBusinessNameChange(fieldCandidate, event) {
    const fieldIdentifier = fieldCandidate;
    const val = assertInstanceOf(event, CustomEvent).detail.value;
    this.onInputChange(fieldIdentifier, val);
  }
  onInputChange(fieldCandidate, valueCandidate) {
    assert(fieldCandidate != null && typeof fieldCandidate === 'string' && (fieldCandidate in AddressFieldIdentifier || fieldCandidate in BusinessFieldIdentifier));
    // FIXME(steckel/jmah): Find a way to type-narrow over type-casting
    const field = fieldCandidate;
    assert(typeof valueCandidate === 'string');
    // FIXME(steckel/jmah): Find a way to type-narrow over type-casting
    const value = valueCandidate;
    this.args.onValueChange({
      field,
      value
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "ein", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "confirmEin", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "einErrorMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "confirmEinErrorMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleCopyPersonalAddressCheckboxClicked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleCopyPersonalAddressCheckboxClicked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initializeFieldKit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFieldKit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBusinessNameChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBusinessNameChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInputChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputChange"), _class.prototype), _class);
export { EditBusinessInformation as default };